/* ============================================================
   LVLY SG "Editorial" - interactions
   - Sticky translucent header past 50px scroll
   - Seasonal hero swap (Birthday / Valentine's / Mother's Day)
   - Mobile nav drawer
   Vanilla JS. Idempotent; re-inits after InstantClick page changes.
   ============================================================ */
(function () {
  'use strict';

  function initHeader() {
    var header = document.querySelector('[data-ed-header]');
    if (!header || header.__edBound) return;
    header.__edBound = true;

    // cart count badge - hide when empty, keep in sync with the theme's .cart_count
    var badge = header.querySelector('[data-ed-cart-badge]');
    var countEl = badge && badge.querySelector('.cart_count');
    function syncBadge() {
      if (!badge || !countEl) return;
      var n = parseInt((countEl.textContent || '0').replace(/\D/g, ''), 10) || 0;
      badge.classList.toggle('is-empty', n <= 0);
    }
    syncBadge();
    if (countEl && window.MutationObserver) {
      new MutationObserver(syncBadge).observe(countEl, { childList: true, characterData: true, subtree: true });
    }

    // expandable search
    var searchToggle = header.querySelector('[data-ed-search-toggle]');
    var searchWrap = header.querySelector('[data-ed-search]');
    var searchInput = searchWrap && searchWrap.querySelector('[data-ed-search-input]');
    var searchClose = searchWrap && searchWrap.querySelector('[data-ed-search-close]');
    function openSearch() { if (!searchWrap) return; searchWrap.hidden = false; if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true'); if (searchInput) searchInput.focus(); }
    function closeSearch() { if (!searchWrap) return; searchWrap.hidden = true; if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false'); }
    if (searchToggle && searchWrap) searchToggle.addEventListener('click', function () { searchWrap.hidden ? openSearch() : closeSearch(); });
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchInput) searchInput.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });

    var wrap = header.closest('.shopify-section') || header;
    var setH = function () {
      document.documentElement.style.setProperty('--ed-header-h', wrap.offsetHeight + 'px');
    };
    var last = null;
    var onScroll = function () {
      var scrolled = (window.pageYOffset || document.documentElement.scrollTop) > 50;
      if (scrolled !== last) {
        header.classList.toggle('is-scrolled', scrolled);
        last = scrolled;
        requestAnimationFrame(setH);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setH, { passive: true });
    setH();
    onScroll();
  }

  function initDrawer() {
    var burger = document.querySelector('[data-ed-burger]');
    var drawer = document.querySelector('[data-ed-drawer]');
    var overlay = document.querySelector('[data-ed-overlay]');
    if (!burger || !drawer || burger.__edBound) return;
    burger.__edBound = true;

    var open = function () {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    };
    var close = function () {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    };
    burger.addEventListener('click', open);
    if (overlay) overlay.addEventListener('click', close);
    var closeBtn = drawer.querySelector('[data-ed-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
  }

  function currentSeason(seasons) {
    // Auto rule: Valentine's late-Jan–Feb, Mother's Day Apr–May, else Birthday.
    var now = new Date();
    var m = now.getMonth(); // 0=Jan
    var d = now.getDate();
    if ((m === 0 && d >= 20) || m === 1) return 'valentines';
    if (m === 3 || m === 4) return 'mother';
    return 'birthday';
  }

  function initHero() {
    var hero = document.querySelector('[data-ed-hero]');
    if (!hero || hero.__edBound) return;
    hero.__edBound = true;

    var data;
    try { data = JSON.parse(hero.getAttribute('data-ed-seasons') || '{}'); }
    catch (e) { data = {}; }
    var keys = Object.keys(data);
    if (!keys.length) return;

    var els = {
      img: hero.querySelector('[data-ed-hero-img]'),
      eyebrow: hero.querySelector('[data-ed-hero-eyebrow]'),
      title: hero.querySelector('[data-ed-hero-title]'),
      sub: hero.querySelector('[data-ed-hero-sub]'),
      cta: hero.querySelector('[data-ed-hero-cta]'),
      overlay: hero.querySelector('[data-ed-hero-overlay]')
    };
    var pills = hero.querySelectorAll('[data-ed-season]');

    var apply = function (key) {
      var s = data[key];
      if (!s) return;
      if (els.img && s.img) els.img.setAttribute('src', s.img);
      if (els.eyebrow) els.eyebrow.textContent = s.eyebrow || '';
      if (els.title) els.title.textContent = s.title || '';
      if (els.sub) els.sub.textContent = s.sub || '';
      if (els.cta) {
        els.cta.textContent = s.cta || 'Shop now';
        if (s.url) els.cta.setAttribute('href', s.url);
      }
      // keep the whole-banner link pointing at the same place as the CTA
      if (els.overlay && s.url) els.overlay.setAttribute('href', s.url);
      pills.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-ed-season') === key);
      });
    };

    pills.forEach(function (p) {
      p.addEventListener('click', function () { apply(p.getAttribute('data-ed-season')); });
    });

    // Default: honour section's chosen default unless it's "auto".
    var def = hero.getAttribute('data-ed-default') || 'auto';
    if (def === 'auto' || !data[def]) def = currentSeason(data);
    if (!data[def]) def = keys[0];
    apply(def);
  }

  function initAnnounce() {
    var bar = document.querySelector('[data-ed-announce]');
    if (!bar) return;
    try {
      if (localStorage.getItem('edAnnounceDismissed') === '1') { bar.classList.add('is-hidden'); return; }
    } catch (e) {}
    var btn = bar.querySelector('[data-ed-announce-close]');
    if (!btn || btn.__edBound) return;
    btn.__edBound = true;
    btn.addEventListener('click', function () {
      bar.classList.add('is-hidden');
      try { localStorage.setItem('edAnnounceDismissed', '1'); } catch (e) {}
      window.dispatchEvent(new Event('resize')); // recompute --ed-header-h
    });
  }

  function initCollection() {
    var root = document.querySelector('[data-ed-collection]');
    if (!root || root.__edBound) return;
    root.__edBound = true;

    var cards = [].slice.call(root.querySelectorAll('.ed-ccard'));
    var typeBtns = [].slice.call(root.querySelectorAll('[data-ed-type]'));
    var countEl = root.querySelector('[data-ed-count]');
    var state = { type: 'all' };

    function apply() {
      var n = 0;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var show = state.type === 'all' || c.getAttribute('data-type') === state.type;
        c.style.display = show ? '' : 'none';
        if (show) n++;
      }
      if (countEl) countEl.textContent = n + (n === 1 ? ' gift' : ' gifts');
    }

    typeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.type = b.getAttribute('data-ed-type');
        typeBtns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        apply();
      });
    });
    var sortSel = root.querySelector('[data-ed-sort]');
    if (sortSel) sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    apply();
  }

  function formatMoney(cents, format) {
    cents = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : cents;
    var fmt = format || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function withDelim(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelim(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelim(cents, 0, '.', ','); break;
      default: value = withDelim(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function initPdp() {
    var root = document.querySelector('[data-ed-pdp]');
    if (!root || root.__edBound) return;
    root.__edBound = true;

    var fmt = root.getAttribute('data-money-format') || '${{amount}}';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var money = function (c) { return formatMoney(c, fmt); };

    var state = { sizeId: null, sizePrice: 0, sizeLabel: '',
      jarId: null, jarPrice: 0, jarLabel: '', jarPersonalise: false, jarText: '', addons: {}, photoAddonId: null };

    // --- gallery ---

    var mainSlider = root.querySelector('[data-ed-pdp-main-slider]');
    var thumbSlider = root.querySelector('[data-ed-pdp-thumbs-slider]');

    function initGallery() {
      if (!mainSlider || !window.Flickity) return;
      if (mainSlider.classList.contains('flickity-enabled')) return; // guard double-init
      var slideCount = mainSlider.querySelectorAll('.ed-pdp__slide').length;
      var main = new window.Flickity(mainSlider, {
        cellSelector: '.ed-pdp__slide',
        pageDots: false,
        prevNextButtons: slideCount > 1,
        wrapAround: true,
        contain: true,
        imagesLoaded: true,
        adaptiveHeight: false
      });
   
      var chevPrev = '<svg class="ed-pdp__chev" viewBox="0 0 44 44" aria-hidden="true"><path d="M15 4 L7 12 L15 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var chevNext = '<svg class="ed-pdp__chev" viewBox="0 0 44 44" aria-hidden="true"><path d="M9 4 L17 12 L9 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var pvBtn = mainSlider.querySelector('.flickity-prev-next-button.previous');
      var nxBtn = mainSlider.querySelector('.flickity-prev-next-button.next');
      if (pvBtn) pvBtn.innerHTML = chevPrev;
      if (nxBtn) nxBtn.innerHTML = chevNext;
      if (thumbSlider) {
      
        new window.Flickity(thumbSlider, {
          asNavFor: mainSlider,
          cellSelector: '.ed-pdp__thumb',
          pageDots: false,
          prevNextButtons: false,
          contain: true,
          cellAlign: 'left'
        });
      }
      window.addEventListener('load', function () { main.resize(); });
    }

   
    if (window.Flickity) {
      initGallery();
    } else if (document.readyState === 'loading' || document.readyState === 'interactive') {
      document.addEventListener('DOMContentLoaded', initGallery);
      window.addEventListener('load', initGallery); // belt-and-suspenders fallback
    } else {
      window.addEventListener('load', initGallery);
    }

    // --- size ---
    var sizeEls = root.querySelectorAll('[data-ed-size]');
    function pickSize(el) {
      state.sizeId = el.getAttribute('data-variant-id');
      state.sizePrice = parseInt(el.getAttribute('data-price'), 10) || 0;
      state.sizeLabel = el.getAttribute('data-label') || '';
      if (el.tagName === 'BUTTON') sizeEls.forEach(function (x) { x.classList.toggle('is-active', x === el); });
      render();
    }
    var initialSize = root.querySelector('[data-ed-size].is-active') || sizeEls[0];
    sizeEls.forEach(function (el) { if (el.tagName === 'BUTTON') el.addEventListener('click', function () { if (!el.disabled) pickSize(el); }); });
    if (initialSize) pickSize(initialSize);

    // --- jar message ---
    var jarText = root.querySelector('[data-ed-jartext]');
    var jarInput = root.querySelector('[data-ed-jartext-input]');
    var jarCount = root.querySelector('[data-ed-jartext-count]');
    var jarEls = root.querySelectorAll('[data-ed-jar]');
    function pickJar(el) {
      jarEls.forEach(function (x) { x.classList.toggle('is-active', x === el); });
      state.jarId = el.getAttribute('data-variant-id') || null;
      state.jarPrice = parseInt(el.getAttribute('data-price'), 10) || 0;
      state.jarLabel = el.getAttribute('data-label') || '';
      state.jarPersonalise = el.getAttribute('data-personalise') === 'true';
      if (state.jarPersonalise) {
        if (jarText) jarText.hidden = false;
        if (jarInput) jarInput.focus();
      } else {
        state.jarText = '';
        if (jarInput) jarInput.value = '';
        if (jarCount) jarCount.textContent = '20';
        if (jarText) jarText.hidden = true;
      }
      render();
    }
    jarEls.forEach(function (el) { el.addEventListener('click', function () { pickJar(el); }); });
    if (jarEls.length) pickJar(jarEls[0]);
    if (jarInput) jarInput.addEventListener('input', function () {
      state.jarText = jarInput.value.slice(0, 20);
      if (jarCount) jarCount.textContent = String(20 - state.jarText.length);
    });

    // --- add-on category filter ---
    var catBtns = root.querySelectorAll('[data-ed-cat]');
    var addonEls = root.querySelectorAll('[data-ed-addon]');
    function applyCatFilter(cat) {
      addonEls.forEach(function (a) {
        a.style.display = (cat === 'all' || a.getAttribute('data-cat') === cat) ? '' : 'none';
      });
    }
    catBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        catBtns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        applyCatFilter(b.getAttribute('data-ed-cat'));
      });
    });
    // Apply the initially-active category on load (e.g. "Sweets" pre-selected).
    var activeCat = root.querySelector('[data-ed-cat].is-active');
    if (activeCat) {
      var initCat = activeCat.getAttribute('data-ed-cat');
      applyCatFilter(initCat);
      // Fallback: if the pre-selected category has no items, revert to "All" so the step isn't empty.
      var anyVisible = [].some.call(addonEls, function (a) { return a.style.display !== 'none'; });
      if (!anyVisible && initCat !== 'all') {
        catBtns.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-ed-cat') === 'all'); });
        applyCatFilter('all');
      }
    }

    // --- photo upload reveal ---
    // Two modes, mirroring the live theme:
    //   product-level  - the product itself is tagged product:imageupload, so the
    //                    uploader is always shown and the photo is mandatory;
    //   add-on-level   - revealed only while a tagged add-on is selected.
    var photoWrap = root.querySelector('[data-ed-photo]');
    var photoRequired = !!(photoWrap && photoWrap.getAttribute('data-ed-photo-required') === 'true');
    function updatePhotoReveal() {
      if (!photoWrap) return;
      state.photoAddonId = null;
      addonEls.forEach(function (a) {
        if (a.getAttribute('data-photo-upload') === 'true' && state.addons[a.getAttribute('data-variant-id')] != null) {
          state.photoAddonId = a.getAttribute('data-variant-id');
        }
      });
      // A product-level uploader stays put: never hide it, and never discard an
      // already-uploaded photo just because add-on selection changed.
      if (photoRequired) { photoWrap.hidden = false; return; }
      var on = !!state.photoAddonId;
      photoWrap.hidden = !on;
      if (!on) {
        photoWrap.removeAttribute('data-photo-url');
        var prev = photoWrap.querySelector('[data-ed-photo-preview]');
        if (prev) prev.innerHTML = '';
      }
    }

    // --- add-on toggle ---
    addonEls.forEach(function (a) {
      var btn = a.querySelector('[data-ed-addon-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = a.getAttribute('data-variant-id');
        if (state.addons[id]) { delete state.addons[id]; a.classList.remove('is-added'); }
        else { state.addons[id] = parseInt(a.getAttribute('data-price'), 10) || 0; a.classList.add('is-added'); }
        render();
        updatePhotoReveal();
      });
    });
    updatePhotoReveal();

    // --- sort add-ons by best-selling (reorder from a lightweight handles-only view) ---
    var addonsWrap = root.querySelector('[data-ed-addons]');
    var bsUrl = addonsWrap && addonsWrap.getAttribute('data-bestselling-url');
    if (addonsWrap && bsUrl) {
      fetch(bsUrl)
        .then(function (r) { return r.json(); })
        .then(function (order) {
          if (!Array.isArray(order) || !order.length) return;
          var rank = {};
          order.forEach(function (h, i) { rank[h] = i; });
          var cards = [].slice.call(addonsWrap.querySelectorAll('[data-ed-addon]'));
          cards.sort(function (a, b) {
            var ra = rank[a.getAttribute('data-handle')]; if (ra == null) ra = 9999;
            var rb = rank[b.getAttribute('data-handle')]; if (rb == null) rb = 9999;
            return ra - rb;
          });
          cards.forEach(function (c) { addonsWrap.appendChild(c); });
        }).catch(function () {});
    }

    // --- render total + summary ---
    var totalEl = root.querySelector('[data-ed-total]');
    var summaryEl = root.querySelector('[data-ed-summary]');
    var priceEl = root.querySelector('[data-ed-pdp-price]');
    function render() {
      var total = state.sizePrice + state.jarPrice;
      var addonCount = 0;
      Object.keys(state.addons).forEach(function (id) { total += state.addons[id]; addonCount++; });
      if (totalEl) totalEl.textContent = money(total);
      if (priceEl) priceEl.textContent = money(state.sizePrice);
      var bits = ['1 ' + state.sizeLabel + (root.classList.contains('ed-pdp--jar') ? ' jar' : '')];
      if (state.jarPersonalise) bits.push('personalised');
      else if (state.jarLabel) bits.push(state.jarLabel);
      if (addonCount) bits.push(addonCount + ' add-on' + (addonCount > 1 ? 's' : ''));
      if (summaryEl) summaryEl.textContent = bits.join(' · ');
    }

    // --- add to cart ---
    var atc = root.querySelector('[data-ed-atc]');
    if (atc) atc.addEventListener('click', function () {
      if (!state.sizeId) return;
      var items = [{ id: Number(state.sizeId), quantity: 1 }];
      // Product-level photo upload: the photo belongs to the product's own line
      // and is required, matching the live theme's 'Personalised Polaroid' property.
      if (photoRequired) {
        var mainUrl = photoWrap && photoWrap.getAttribute('data-photo-url');
        if (!mainUrl) {
          alert('Please upload your photo before adding to cart.');
          var mb = root.querySelector('[data-ed-photo-btn]');
          if (mb) mb.scrollIntoView({ block: 'center' });
          return;
        }
        items[0].properties = { 'Personalised Polaroid': mainUrl };
      }
      // selected jar becomes its own cart line (so paid jars are charged)
      if (state.jarId) {
        var jarLine = { id: Number(state.jarId), quantity: 1 };
        if (state.jarPersonalise && state.jarText) jarLine.properties = { 'Jar message': state.jarText };
        items.push(jarLine);
      }
      // require a photo when a photo-upload add-on is selected
      if (state.photoAddonId) {
        var pUrl = photoWrap && photoWrap.getAttribute('data-photo-url');
        if (!pUrl) {
          alert('Please upload your photo for the Personalised Photo add-on before adding to cart.');
          var pb = root.querySelector('[data-ed-photo-btn]');
          if (pb) pb.scrollIntoView({ block: 'center' });
          return;
        }
      }
      Object.keys(state.addons).forEach(function (id) {
        var item = { id: Number(id), quantity: 1 };
        if (state.photoAddonId && id === state.photoAddonId) {
          var url = photoWrap && photoWrap.getAttribute('data-photo-url');
          if (url) item.properties = { 'Personalised Polaroid': url };
        }
        items.push(item);
      });

      atc.disabled = true;
      atc.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        window.location.href = cartUrl;
      }).catch(function (err) {
        atc.disabled = false;
        atc.textContent = 'Add to cart →';
        console.error('[ed-pdp] add to cart failed', err);
        alert((err && err.description) || 'Sorry - something went wrong adding to cart.');
      });
    });

    render();
  }

  function initCart() {
    var root = document.querySelector('[data-ed-cart]');
    if (!root || root.__edBound) return;
    root.__edBound = true;

    var MS = 86400000;
    var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var MONF = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var fmt = function (d) { return d.getDate() + ' ' + MON[d.getMonth()]; };
    var attrLabel = function (d) { return DAY[d.getDay()] + ', ' + d.getDate() + ' ' + MON[d.getMonth()] + ' ' + d.getFullYear(); };
    // Canonical attribute format (dd/mm/yyyy) - matches the old theme's datepicker and the
    // external channels, so downstream systems see one consistent delivery_date format.
    var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
    var attrValue = function (d) { return pad2(d.getDate()) + '/' + pad2(d.getMonth() + 1) + '/' + d.getFullYear(); };

    // "Now" in Hong Kong time (UTC+8), regardless of the shopper's device timezone -
    // mirrors the live theme's delivery-date.js offset trick so cutoffs match ops hours.
    var nowSG = (function () { var l = new Date(); return new Date(l.getTime() + (l.getTimezoneOffset() + 480) * 60000); })();
    var sameYMD = function (a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); };

    // Delivery-window availability for a selected date, ported from the live theme's
    // showTimeslot() cutoff logic. Returns [slot1 (10-2), slot2 (2-6), slot3 (6-10pm)].
    // Slots: 1 = morning, 2 = afternoon, 3 = evening.
    function slotAvail(sel) {
      var h = nowSG.getHours();
      var tDow = nowSG.getDay();               // day of week, today (SGT)
      var sDow = sel.getDay();                  // day of week, selected delivery date
      var sgTom = new Date(nowSG.getFullYear(), nowSG.getMonth(), nowSG.getDate() + 1);
      var isToday = sameYMD(sel, nowSG);
      var isTom = sameYMD(sel, sgTom);
      var s1 = false, s2 = false, s3 = false;

      if (isToday) {
        // Same-day cutoffs
        if (tDow !== 0) {                       // Mon–Sat
          if (h >= 17) { /* after 5pm: no same-day */ }
          else if (h >= 13) { s3 = true; }     // after 1pm: evening only
          else { s2 = true; s3 = true; }       // before 1pm: 10-2 already gone
        } else {                               // Sunday same-day
          if (h > 14) { /* after 2pm: none */ }
          else { s2 = true; }                  // before 2pm: 2-6pm only
        }
      } else {
        // Future date
        if (tDow !== 0) {                       // ordering on a Mon–Sat
          if (h > 16) { s1 = !isTom; s2 = true; s3 = true; } // after 5pm: next-day loses 10-2
          else { s1 = true; s2 = true; s3 = true; }
          // if (sDow === 0) { s3 = false; }       // Sunday delivery: no evening
        } else {                               // ordering on a Sunday
          if (h > 16) { s1 = !isTom; s2 = true; s3 = true; }
          else if (h > 14) { s1 = true; s2 = true; s3 = false; }
          else { s1 = true; s2 = true; s3 = true; }
        }
      }

      if (attrValue(sel) === '25/09/2026') { s3 = false; }
       if (attrValue(sel) === '26/09/2026') { s1 = false; }
      // Universal evening-slot rules (apply no matter what day it is today).
      // Closes the live theme's gap where a Sunday-for-Sunday order still showed 6-10pm.
      // if (sDow === 6) { s3 = false; }           // Saturday delivery: no evening
      // if (sDow === 0) { s3 = false; }           // Sunday delivery: shop closed 6-10pm
      return [s1, s2, s3];
    }

    var state = { date: null, dateLabel: '', dateValue: '', slot: '', calMonth: 0, calOpen: false };

    var quickWrap = root.querySelector('[data-ed-quickdays]');
    var calWrap = root.querySelector('[data-ed-calendar]');
    var slotBtns = [].slice.call(root.querySelectorAll('[data-ed-slot]'));
    var slotNote = root.querySelector('[data-ed-slots-note]');
    var whenEl = root.querySelector('[data-ed-when]');

    // Reflect slot availability for the currently-selected date onto the buttons.
    function refreshSlots() {
      if (!state.date) {
        slotBtns.forEach(function (b) { b.disabled = false; b.classList.remove('is-unavailable'); });
        if (slotNote) slotNote.hidden = true;
        return false;
      }
      var av = slotAvail(state.date);
      var anyAvail = false, cleared = false;
      slotBtns.forEach(function (b, i) {
        var ok = !!av[i];
        if (ok) anyAvail = true;
        b.disabled = !ok;
        b.classList.toggle('is-unavailable', !ok);
        if (!ok && b.getAttribute('data-value') === state.slot) {
          state.slot = '';                     // drop a now-invalid selection
          b.classList.remove('is-active');
          cleared = true;
        }
      });
      if (slotNote) slotNote.hidden = anyAvail;
      return cleared;
    }

    // state.slot holds the delivery_slot attribute value ("Between 9am and 1pm"),
    // which is what fulfilment reads. The button text is the shopper-facing label
    // ("9 AM - 1 PM"), so resolve back to it for the on-page summary.
    function slotLabelFor(value) {
      if (!value) return '';
      for (var i = 0; i < slotBtns.length; i++) {
        if (slotBtns[i].getAttribute('data-value') === value) {
          return (slotBtns[i].textContent || '').trim() || value;
        }
      }
      return value;
    }

    function saveAttributes() {
      // Save the machine formats: date as dd/mm/yyyy, slot as the live theme's
      // "Between 9am and 1pm" wording. Both labels are display-only.
      var body = { attributes: { delivery_date: state.dateValue || '', delivery_slot: state.slot || '' } };
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (whenEl) whenEl.textContent = [state.dateLabel, slotLabelFor(state.slot)].filter(Boolean).join(' · ');
    }

    function pickDate(d) {
      state.date = d;
      state.dateLabel = attrLabel(d);
      state.dateValue = attrValue(d);
      state.calOpen = false;
      refreshSlots();          // recompute window availability (clears a now-invalid slot)
      // Keep a slot always selected: if none is selected/valid, pick the earliest available one.
      if (!state.slot) {
        var idx = firstAvailableSlotIndex(d);
        if (idx >= 0) { selectSlotByIndex(idx); }
      }
      renderQuickDays();
      renderCalendar();
      saveAttributes();
    }

    function renderQuickDays() {
      if (!quickWrap) return;
      quickWrap.innerHTML = '';
      for (var i = 0; i < 3; i++) {
        var d = new Date(today.getTime() + i * MS);
        var active = state.date && d.getTime() === state.date.getTime();
        // "Today" is unselectable once its cutoff has passed (no windows left).
        var av = slotAvail(d);
        var noWindows = !av[0] && !av[1] && !av[2];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ed-day' + (active ? ' is-active' : '') + (noWindows ? ' is-unavailable' : '');
        b.disabled = noWindows;
        b.innerHTML = '<span class="ed-day__name">' + (i === 0 ? 'Today' : DAY[d.getDay()]) + '</span><span class="ed-day__date">' + fmt(d) + '</span>';
        if (!noWindows) { (function (dd) { b.addEventListener('click', function () { pickDate(dd); }); })(d); }
        quickWrap.appendChild(b);
      }
      var far = state.date && (state.date.getTime() - today.getTime()) / MS > 2;
      var pick = document.createElement('button');
      pick.type = 'button';
      pick.className = 'ed-day ed-day--pick' + (far || state.calOpen ? ' is-active' : '');
      pick.innerHTML = far
        ? '<span class="ed-day__name">' + DAY[state.date.getDay()] + '</span><span class="ed-day__date">' + fmt(state.date) + '</span>'
        : '<span class="ed-day__name">Pick a date</span><span class="ed-day__date">📅 Calendar</span>';
      pick.addEventListener('click', function () { state.calOpen = !state.calOpen; renderCalendar(); renderQuickDays(); });
      quickWrap.appendChild(pick);
    }

    function renderCalendar() {
      if (!calWrap) return;
      calWrap.hidden = !state.calOpen;
      if (!state.calOpen) { calWrap.innerHTML = ''; return; }
      var first = new Date(today.getFullYear(), today.getMonth() + state.calMonth, 1);
      var label = MONF[first.getMonth()] + ' ' + first.getFullYear();
      var startPad = first.getDay();
      var daysIn = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
      var html = '<div class="ed-cal__head">' +
        '<button type="button" class="ed-cal__nav" data-cal-prev' + (state.calMonth <= 0 ? ' disabled' : '') + '>‹</button>' +
        '<div class="ed-cal__label">' + label + '</div>' +
        '<button type="button" class="ed-cal__nav" data-cal-next' + (state.calMonth >= 3 ? ' disabled' : '') + '>›</button></div>';
      html += '<div class="ed-cal__grid ed-cal__weekdays">';
      ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].forEach(function (w) { html += '<div class="ed-cal__wd">' + w + '</div>'; });
      html += '</div><div class="ed-cal__grid ed-cal__days">';
      for (var p = 0; p < startPad; p++) html += '<span class="ed-cal__cell ed-cal__cell--blank"></span>';
      for (var dn = 1; dn <= daysIn; dn++) {
        var d = new Date(first.getFullYear(), first.getMonth(), dn);
        var past = d.getTime() < today.getTime();
        var active = state.date && d.getTime() === state.date.getTime();
        html += '<button type="button" class="ed-cal__cell' + (past ? ' is-past' : '') + (active ? ' is-active' : '') + '"' +
          (past ? ' disabled' : ' data-cal-day="' + d.getTime() + '"') + '>' + dn + '</button>';
      }
      html += '</div>';
      calWrap.innerHTML = html;
      var prev = calWrap.querySelector('[data-cal-prev]'); if (prev) prev.addEventListener('click', function () { state.calMonth = Math.max(0, state.calMonth - 1); renderCalendar(); });
      var next = calWrap.querySelector('[data-cal-next]'); if (next) next.addEventListener('click', function () { state.calMonth = Math.min(3, state.calMonth + 1); renderCalendar(); });
      calWrap.querySelectorAll('[data-cal-day]').forEach(function (c) {
        c.addEventListener('click', function () { pickDate(new Date(parseInt(c.getAttribute('data-cal-day'), 10))); });
      });
    }

    // slots
    slotBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.slot = b.getAttribute('data-value');
        slotBtns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        saveAttributes();
      });
    });

    // message note (debounced save) + counter + suggestions
    var note = root.querySelector('[data-ed-note]');
    var noteCount = root.querySelector('[data-ed-note-count]');
    var noteTimer = null;
    function saveNote() {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
    function onNote() {
      if (noteCount) noteCount.textContent = String(250 - note.value.length);
      clearTimeout(noteTimer); noteTimer = setTimeout(saveNote, 600);
    }
    if (note) { note.addEventListener('input', onNote); note.addEventListener('blur', saveNote); }
    root.querySelectorAll('[data-ed-suggestion]').forEach(function (s) {
      s.addEventListener('click', function () { if (note) { note.value = s.getAttribute('data-full'); onNote(); note.focus(); } });
    });

    // cart mutation helpers (reload after to reflect subtotal)
    function change(id, qty) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty }) });
    }
    function reload() { window.location.reload(); }

    // qty steppers + remove
    root.querySelectorAll('[data-ed-line]').forEach(function (line) {
      var key = line.getAttribute('data-key');
      var valEl = line.querySelector('[data-ed-qty-val]');
      line.querySelectorAll('[data-ed-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var cur = parseInt(valEl.textContent, 10) || 1;
          var next = btn.getAttribute('data-ed-qty') === 'inc' ? cur + 1 : cur - 1;
          if (next < 0) return;
          // qty 0 removes the line item
          btn.disabled = true;
          change(key, next).then(reload);
        });
      });
      var rm = line.querySelector('[data-ed-remove]');
      if (rm) rm.addEventListener('click', function () { rm.disabled = true; change(key, 0).then(reload); });
    });

    // greeting cards: one card per order. One request swaps the card (every card
    // already in the cart set to 0, the picked one to 1), then only the cart
    // section is re-drawn in place: no page reload, no jump. Tapping the ticked
    // card removes it. All cards are locked while this runs.
    root.querySelectorAll('[data-ed-greeting]').forEach(function (g) {
      g.addEventListener('click', function () {
        if (root.__edGreetingBusy) return;
        root.__edGreetingBusy = true;
        var vid = String(g.getAttribute('data-variant-id'));
        var wasSelected = g.classList.contains('is-selected');

        // Instant feedback: tick/untick straight away, lock the rest.
        root.querySelectorAll('[data-ed-greeting]').forEach(function (x) {
          x.classList.toggle('is-selected', !wasSelected && x === g);
          x.style.pointerEvents = 'none';
        });

        var updates = {};
        root.querySelectorAll('[data-ed-line][data-greeting="true"]').forEach(function (l) {
          var v = l.getAttribute('data-variant-id');
          if (v) updates[v] = 0;
        });
        if (!wasSelected) updates[vid] = 1;

        var sectionEl = root.closest('.shopify-section');
        var sectionId = sectionEl && sectionEl.id ? sectionEl.id.replace('shopify-section-', '') : null;
        var body = { updates: updates };
        if (note) body.note = note.value;          // keep any message typed but not yet saved
        if (sectionId) body.sections = sectionId;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) throw new Error('update failed');
          return r.json();
        }).then(function (cart) {
          var html = sectionId && cart.sections && cart.sections[sectionId];
          if (!html) { reload(); return; }
          var y = window.pageYOffset;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#shopify-section-' + sectionId) || tmp.firstElementChild;
          sectionEl.replaceWith(fresh);
          window.scrollTo(0, y);
          document.querySelectorAll('.cart_count').forEach(function (c) { c.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: sectionId } }));
        }).catch(reload);
      });
    });

    // checkout (blocked when the cart is only add-ons)
    var hasGift = root.getAttribute('data-has-gift') === 'true';
    root.querySelectorAll('[data-ed-checkout]').forEach(function (c) {
      c.addEventListener('click', function () {
        if (!hasGift) return;
        window.location.href = '/checkout';
      });
    });

    // ----- Default selection: always keep a valid date + next-available slot selected -----
    // The old theme computed the earliest available date (past cutoffs) but never pre-selected it;
    // here we pre-select it (today when the shop is still open, else the next available day) plus
    // the earliest available slot, so a delivery date/slot is never empty at checkout.
    function parseDateLabel(label) {
      if (!label) return null;
      var d;
      var m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(label);
      if (m) {
        d = new Date(+m[3], +m[2] - 1, +m[1]); // canonical "dd/mm/yyyy"
      } else {
        d = new Date(label.replace(/^[A-Za-z]+,\s*/, '')); // legacy "Wed, 8 Jul 2026" -> "8 Jul 2026"
      }
      if (isNaN(d.getTime())) return null;
      d.setHours(0, 0, 0, 0);
      return d;
    }
    function dateHasSlot(d) { var av = slotAvail(d); return av[0] || av[1] || av[2]; }
    function earliestAvailableDate() {
      for (var i = 0; i < 90; i++) {
        var d = new Date(today.getTime() + i * MS);
        if (dateHasSlot(d)) return d;
      }
      return new Date(today.getTime());
    }
    function firstAvailableSlotIndex(d) {
      var av = slotAvail(d);
      for (var i = 0; i < 3; i++) { if (av[i]) return i; }
      return -1;
    }
    function selectSlotByIndex(idx) {
      slotBtns.forEach(function (x, xi) { x.classList.toggle('is-active', xi === idx); });
      state.slot = idx >= 0 ? slotBtns[idx].getAttribute('data-value') : '';
    }
    function applyDefaults(a) {
      // Date: reuse a still-valid saved date, else the earliest available (today when the shop is open).
      var saved = parseDateLabel(a.delivery_date);
      var d = (saved && saved.getTime() >= today.getTime() && dateHasSlot(saved)) ? saved : earliestAvailableDate();

      // Slot: reuse the saved slot if still available on this date, else the earliest available slot.
      var av = slotAvail(d);
      var savedIdx = -1;
      if (a.delivery_slot) {
        for (var i = 0; i < slotBtns.length; i++) {
          if (slotBtns[i].getAttribute('data-value') === a.delivery_slot) { savedIdx = i; break; }
        }
      }
      var idx = (savedIdx >= 0 && av[savedIdx]) ? savedIdx : firstAvailableSlotIndex(d);

      // Set the slot on state BEFORE pickDate so its single saveAttributes() persists date + slot
      // together (two separate posts would race, and the empty-slot one could win).
      state.slot = idx >= 0 ? slotBtns[idx].getAttribute('data-value') : '';
      pickDate(d);            // selects/highlights the date, refreshes availability, persists date + slot
      selectSlotByIndex(idx); // set the active slot button visually (refreshSlots doesn't add is-active)
    }

    renderQuickDays();
    renderCalendar();
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) { applyDefaults(cart.attributes || {}); })
      .catch(function () { applyDefaults({}); });
  }

  // Drag-to-scroll for the occasion tile rows (mouse/desktop).
  // Mobile touch/pen keep native overflow-x scrolling - we only hijack the mouse.
  // Pointer capture guarantees we get the release; killing dragstart stops the
  // browser's native link/image drag (the "copy" ghost that used to eat mouseup).
  function initOccasions() {
    var rows = document.querySelectorAll('[data-ed-occ]');
    [].forEach.call(rows, function (row) {
      if (row.__edOccBound) return;
      row.__edOccBound = true;

      var isDown = false, startX = 0, startScroll = 0, dragging = false, suppressClick = false, pointerId = null;
      var THRESHOLD = 6; // px of movement before a press becomes a drag rather than a click

      // Never let the browser start a native drag-and-drop on the tiles/images.
      row.addEventListener('dragstart', function (e) { e.preventDefault(); });

      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return; // touch/pen -> native scroll
        isDown = true; dragging = false; suppressClick = false; pointerId = e.pointerId;
        startX = e.clientX; startScroll = row.scrollLeft;
      });

      row.addEventListener('pointermove', function (e) {
        if (!isDown || e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        if (!dragging && Math.abs(dx) > THRESHOLD) {
          dragging = true;
          row.classList.add('is-grabbing');
          try { row.setPointerCapture(pointerId); } catch (err) {} // keep events even off-row
        }
        if (dragging) { row.scrollLeft = startScroll - dx; }
      });

      function endDrag(e) {
        if (!isDown || (e && e.pointerId !== pointerId)) return;
        isDown = false;
        row.classList.remove('is-grabbing');
        try { if (pointerId !== null) row.releasePointerCapture(pointerId); } catch (err) {}
        pointerId = null;
        if (dragging) { suppressClick = true; } // swallow the click that trails a drag
      }
      row.addEventListener('pointerup', endDrag);
      row.addEventListener('pointercancel', endDrag);

      // Capture-phase guard: cancel the tile link only when we actually dragged.
      row.addEventListener('click', function (e) {
        if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; }
      }, true);
    });
  }

  /* ---- Judge.me review carousel: sharper product thumbnails ----
     Judge.me hard-codes 70x70 (and 140x140 retina) product thumbnails, which
     the editorial card renders at roughly 237x150 - heavily upscaled and
     visibly pixelated. The images sit on the store's own Shopify CDN, so we
     just ask it for a larger rendition by rewriting the size suffix.
     Judge.me injects the carousel asynchronously and rebuilds it on resize,
     so this watches for thumbnails rather than running a single pass. */
  var JDGM_THUMB = '.jdgm-carousel-item__product-image:not([data-ed-thumb])';
  var CDN_SIZE_RE = /_\d+x\d*(?=\.(?:jpe?g|png|webp)(?:$|\?))/i;
  // Judge.me serves these as cdn.shopify.com/s/files/..., not the
  // storefront's /cdn/shop/... form. Accept both.
  var CDN_PATH_RE = /\/(?:cdn\/shop|s\/files)\//;

  function resizedCdnUrl(url, px) {
    if (!url || !CDN_PATH_RE.test(url)) return null;
    if (!CDN_SIZE_RE.test(url)) return null;
    var next = url.replace(CDN_SIZE_RE, '_' + px + 'x');
    return next === url ? null : next;
  }

  function upgradeThumb(img) {
    // Not populated yet - leave unflagged so a later mutation retries.
    if (!img.getAttribute('data-src') && !img.getAttribute('src')) return;
    var changed = false;
    [['data-src', 600], ['data-src-retina', 900], ['src', 600]].forEach(function (pair) {
      var next = resizedCdnUrl(img.getAttribute(pair[0]), pair[1]);
      if (next) { img.setAttribute(pair[0], next); changed = true; }
    });
    // Flag either way so resolved thumbnails aren't rescanned on every mutation.
    img.setAttribute('data-ed-thumb', changed ? '1' : '0');
  }

  function upgradeThumbs() {
    Array.prototype.forEach.call(document.querySelectorAll(JDGM_THUMB), upgradeThumb);
  }

  function initReviewThumbs() {
    upgradeThumbs();
    if (document.__edThumbObs || !window.MutationObserver) return;
    // childList only: our own attribute writes must not re-trigger this.
    document.__edThumbObs = new MutationObserver(upgradeThumbs);
    document.__edThumbObs.observe(document.body, { childList: true, subtree: true });
  }

  function initAll() {
    initHeader();
    initDrawer();
    initHero();
    initAnnounce();
    initCollection();
    initPdp();
    initCart();
    initOccasions();
    initReviewThumbs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after InstantClick swaps page content.
  if (window.InstantClick && typeof window.InstantClick.on === 'function') {
    window.InstantClick.on('change', initAll);
  }
  // Shopify theme editor re-render
  document.addEventListener('shopify:section:load', initAll);
})();